import { LinkList } from "./linklist.view";

export default LinkList;
